import { typography } from '@joor/design-system'
import styled, { css } from 'styled-components'

import checkboxIndeterminate from 'assets/images/icon_checkbox_indeterminate.svg'
import checkboxOff from 'assets/images/icon_checkbox_off.svg'
import checkboxOn from 'assets/images/icon_checkbox_on.svg'

const checkboxProps = css`
  background-position: center;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: var(--size-border-radius-small);
  background-repeat: no-repeat;
  &::after {
    content: '' !important;
  }
  &::before {
    content: '' !important;
  }
`

export const AgGridLayout = styled.div`
  background-color: var(--color-neutral-000-full);
  box-sizing: border-box;
  height: calc(100vh - 150px);

  &.ag-theme-balham {
    & .ag-root-wrapper {
      height: 100%;
      border: none;
      ${typography.alpha.primaryActive.body3}

      & .ag-menu {
        font-family: var(--font-family-alpha);
        font-size: var(--size-font-small);
        font-weight: var(--font-weight-regular);
      }

      & .ag-checkbox-input-wrapper {
        background-color: var(--color-primary-400);
        ${checkboxProps}
        mask: url(${checkboxOff}) no-repeat;
        mask-size: 24px;

        &.ag-checked {
          background-color: var(--color-secondary-800);
          mask: url(${checkboxOn}) no-repeat;
        }

        &.ag-indeterminate {
          background-color: var(--color-secondary-800);
          mask: url(${checkboxIndeterminate}) no-repeat;
        }

        & .ag-checkbox-input {
          cursor: pointer;
        }

        &:focus-within,
        &:active {
          box-shadow: none;
        }
      }

      & .ag-row-selected {
        background-color: var(--color-secondary-200) !important;
      }

      & .ag-selection-checkbox,
      & .ag-header-select-all {
        margin-left: 8px;
        padding: 0px;
        & .ag-react-container {
          display: none !important;
        }
      }

      & .ag-header {
        background-color: var(--color-secondary-100);
        border-bottom: none;
        width: fit-content;

        & .ag-header-row {
          background-color: var(--color-secondary-100);
          border: none;
          border-bottom: 1px solid var(--color-primary-400);

          & .ag-header-cell {
            border: none;
            padding: 0 12px;

            & .ag-icon {
              color: var(--color-primary-400);
            }

            &::after {
              display: none;
            }
            & .ag-header-cell-label {
              border-right: none !important;
              border-left: none !important;
              text-align: left;
            }
            & .ag-header-cell-text {
              ${typography.alpha.primaryInactive.body2}
              color: var(--color-primary-500);
            }

            .ag-react-container {
              display: flex;
              align-items: center;
              height: 100%;
              width: 100%;
            }
          }
        }
      }

      & .ag-pinned-left-header,
      & .ag-pinned-left-cols-container {
        border-right: 2px solid var(--color-secondary-600);
      }

      & .ag-horizontal-left-spacer {
        border: none;
      }

      & .ag-layout-auto-height .ag-center-cols-clipper,
      & .ag-layout-auto-height .ag-center-cols-container {
        min-height: auto;
      }

      .ag-body-viewport.ag-layout-auto-height {
        overflow-y: auto;
        max-height: calc(100vh - 250px);
        min-height: 32px;
      }

      & .ag-row {
        background-color: var(--color-neutral-000-full);
        border-color: var(--color-primary-100);
        cursor: pointer;

        & .rightAlignCell {
          text-align: right;
        }

        & .ag-cell {
          ${typography.alpha.primaryActive.body3}
          display: flex;
          align-items: center;

          a {
            color: var(--color-secondary-800);
            text-decoration: none;
          }

          .ag-react-container {
            display: flex;
            align-items: center;
            height: 100%;
          }

          &.allowOverflow {
            overflow: visible;
          }

          &.ag-cell-last-left-pinned {
            border-right: none;
          }

          &.ag-cell-highlight {
            background-color: var(--color-secondary-600) !important;
          }

          &.ag-right-aligned-cell {
            ${typography.numeric.primaryActive.body3}
            display: flex;
            justify-content: flex-end;
          }

          &.ag-cell-focus {
            border: 1px solid transparent;
          }
        }
      }

      & .ag-row-group {
        background-color: var(--color-secondary-100);
      }

      /*
       * We use this negative margin to hide the selection column label which we
       * cannot actually hide because of Ag grid's column width auto calculation
       */
      & [col-id='selection'] {
        margin-right: -24px;
      }
    }
  }

  .ag-tooltip-custom {
    position: absolute;
  }
`
